export default __webpack_public_path__ + "static/media/nutritionIsActive.697ffe4d.svg";